import { EventEmitter } from 'modules/event-emitter';

export interface NavigationEvents {
  onToggleCollapse: { componentID: string; value: boolean; parentID: string | undefined };
}
export const navigationEmitter = new EventEmitter<NavigationEvents>();
